import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";




const ContactUs = () => {
    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(

                "service_2tgflge",
                "template_nwb3d8q",
                "#myForm",
                "ieg4RjjBNF3wSvoaX"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };
    return (
        <>
            <section className="section-breadcrumb main-wrapper">
                <div className="breadcrumb-area">
                    <div className="container">
                        <div className="breadcrumb-wrapper">
                            <nav className="breadcrumb">
                                <Link className="breadcrumb-item" to="/">Home</Link>
                                <span className="breadcrumb-item active" aria-current="page">Contact</span>
                            </nav>
                            <h1 className="breadcrumb-title">Contact Us</h1>
                        </div>
                        <div className="breadcrumb-bg-block">
                            <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                            <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section-get-in-touch" style={{ marginTop: "-40px" }}>
                <div className="section-space">
                    <div className="container">
                        <div className="row g-4 align-items-center">
                            <div className="col-lg-5">
                                <div className="section-content-block mb-4">
                                    <span className="section-tag">Welcome to Rahul Logistics Katni</span>
                                    <h2 className="section-title is-text-dark">
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            Get in touch
                                        </div>
                                    </h2>
                                </div>
                                <ul className="get-touch-info-list">
                                    <li>
                                        <div className="icon-rounded-full">
                                            <i className="fa-light fa-phone" />
                                        </div>
                                        <div className="content">
                                            <span>24/7 Our Support</span>
                                            <a href="tel:+91 8770252599">+91 8770252599</a>
                                            <a href="tel:+91 8719986222">+91 8719986222</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-rounded-full">
                                            <i className="fa-light fa-envelope" />
                                        </div>
                                        <div className="content">
                                            <span>Send Your Message</span>
                                            <a href="mailto:info@mprahullogistics.com">info@mprahullogistics.com</a>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon-rounded-full">
                                            <i className="fa-regular fa-location-dot" />
                                        </div>
                                        <div className="content">
                                            <span><b>Head Office</b></span>
                                            <address>Reg. Off.-275 U, Dwarka City, Jabalpur Road, Katni, Madhya Pradesh</address>
                                            <span><b>Working office</b></span>
                                            <a href='https://share.google/BwiO5okxBEwIIu4GH' target="_blank"> 
                                            <address>P8CG+C7G RAHUL LOGISTICS, NH 30, Paduwa, Madhya Pradesh 483442</address>
                                            </a>
                                            {/* <address>Reg. Off.-275 U, Jabalpur Road, Katni</address> */}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-7">
                                <div className="get-touch-form-block box-shadow-theme">
                                    <form method="POST" onSubmit={sendEmail} id="myForm">
                                        <div className="row g-3">
                                            <div className="col-xl-6">
                                                <input type="text" placeholder="Your name" required
                                                    name="from_name"
                                                    onChange={(e) => nameChange(e)}
                                                    value={name}
                                                    id="name"
                                                />
                                            </div>
                                            <div className="col-xl-6">
                                                <input type="email" placeholder="Your email" required
                                                    id="email"
                                                    name='email'
                                                    onChange={(e) => mailChange(e)}
                                                    value={mail}
                                                />
                                            </div>
                                            <div className="col-xl-6">
                                                <input type="text" placeholder="Your subject" required
                                                    name="subject"
                                                    id="Subject"
                                                    onChange={(e) => subjectChange(e)}
                                                    value={subject}
                                                />
                                            </div>
                                            <div className="col-xl-6">
                                                <input type="tel" placeholder="Phone number" required
                                                    id="phone"
                                                    name='phone'
                                                    onChange={(e) => numberChange(e)}
                                                    value={number}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <textarea placeholder="Your message" cols={30} defaultValue
                                                    id="address"
                                                    onChange={(e) => massagesChange(e)}
                                                    name='massage'
                                                    value={massages}
                                                    required
                                                />
                                            </div>
                                            <div className="col-12">

                                                <button type="submit" className="btn btn-secondary">
                                                    Send Your Message
                                                    <span className="btn-icon">
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="mapouter mt-lg-5"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1200&height=400&hl=en&q=P8CG+C7G RAHUL LOGISTICS, NH 30, Paduwa, Madhya Pradesh 483442&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://wheremylocation.com/">where am i</a></div><style dangerouslySetInnerHTML={{__html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>

                    </div>
                </div>
            </section>







        </>
    )
}

export default ContactUs